function analyticsEmptyMode () {
  return {
    restrict: 'E',
    scope: {
      icon: '@',
      size: '@',
      noDescription: '<'
    },
    templateUrl: '/analytics/directives/analytics-empty-mode/analytics-empty-mode-directive.html?$$REVISION$$'
  }
}

export { analyticsEmptyMode }
